export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  const baseTrad = 'addEditBonReception.rapprochements.errors';
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('RAPPROCHEMENT_LIGNE_LIGNE_BR_AND_CA_MUST_BE_DIFFERENT') === 0) {
      messages.push({ message: `${baseTrad}.ligneBRAndCAMustBeDifferent` });
    }
    if (message.indexOf('RAPPROCHEMENT_LIGNE_LIGNE_BR_AND_CA_MUST_HAVE_THE_SAME_PRODUCT') === 0) {
      messages.push({ message: `${baseTrad}.ligneBRAndCAMustHaveTheSameProduct` });
    }
    if (message.indexOf('RAPPROCHEMENT_LIGNE_LIGNE_BR_AND_CA_MUST_HAVE_THE_SAME_SUPPLIER') === 0) {
      messages.push({ message: `${baseTrad}.ligneBRAndCAMustHaveTheSameSupplier` });
    }
    if (message.indexOf('RAPPROCHEMENT_LIGNE_QUANTITE_MUST_NOT_BE_GREATER_THAN_QUANTITE_RESTE_A_RAPPROCHE_LIGNE_BR') === 0) {
      messages.push({ message: `${baseTrad}.quantiteMustNotBeGreaterThanQuantiteResteARapprocherLigneBR` });
    }
    if (message.indexOf('RAPPROCHEMENT_LIGNE_QUANTITE_MUST_NOT_BE_GREATER_THAN_QUANTITE_RESTE_A_RAPPROCHE_LIGNE_CA') === 0) {
      messages.push({ message: `${baseTrad}.quantiteMustNotBeGreaterThanQuantiteResteARapprocherLigneCA` });
    }
    if (message.indexOf('RAPPROCHEMENT_LIGNE_SUM_RAPPROCHEMENT_LIGNE_MUST_NOT_GREATER_QUANTITY_LINE') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: `${baseTrad}.sumRapprochementLigneMustNOtGeaterQuantityLine`,
        parametres: {
          libelle: params[1],
          codeDcf: params[2],
        },
      });
    }
  });
}
